import {
  dialogSearchFieldSx,
  getDialogPaperSx
} from '../../../constants/dialogSx'
import {
  UI_COLOR_BORDER_DIVIDER_SOFT,
  UI_COLOR_BORDER_SURVEY_SELECTOR,
  UI_COLOR_PRIMARY,
  UI_COLOR_PRIMARY_HOVER,
  UI_COLOR_RBAC_STATUS_PENDING_BG,
  UI_COLOR_SURFACE_300,
  UI_COLOR_SURFACE_DISABLED,
  UI_COLOR_TEXT_DIALOG_META,
  UI_COLOR_WARNING_ACCENT,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'
import { RBAC_USER_SELECTION_SCROLL_LOAD_THRESHOLD_PX } from './rbacUserSelectionDialogConstants'

export const RBAC_ADD_USERS_FILTER_ALL = 'all'
export const RBAC_ADD_USERS_FILTER_UNASSIGNED = 'unassigned'

export const RBAC_ADD_USERS_TITLE = 'Agregar usuarios al rol'
export const RBAC_ADD_USERS_PRIMARY_LABEL = 'Agregar seleccionados'
export const RBAC_ADD_USERS_LOADING_LABEL = 'Agregando...'
export const RBAC_ADD_USERS_EMPTY_STATE_MESSAGE = 'No hay usuarios para mostrar'
export const RBAC_ADD_USERS_LOADING_TEXT = 'Cargando...'
export const RBAC_ADD_USERS_SEARCH_PLACEHOLDER = 'Buscar usuario por nombre o código'
export const RBAC_ADD_USERS_UNASSIGNED_ROLE_LABEL = 'SIN ROL'
export const RBAC_ADD_USERS_SUBMIT_ERROR_MESSAGE = 'No se pudieron agregar los usuarios'
export const RBAC_ADD_USERS_WARNING_ACCENT = UI_COLOR_WARNING_ACCENT
export const RBAC_ADD_USERS_WARNING_BACKGROUND = UI_COLOR_RBAC_STATUS_PENDING_BG

export const RBAC_ADD_USERS_MIN_VISIBLE_ROWS = 5
export const RBAC_ADD_USERS_ROW_MIN_HEIGHT = 68
export const RBAC_ADD_USERS_PAGE_SIZE = 10
export const RBAC_ADD_USERS_SCROLL_LOAD_THRESHOLD_PX = RBAC_USER_SELECTION_SCROLL_LOAD_THRESHOLD_PX

export const rbacAddUsersDialogPaperSx = getDialogPaperSx(720)

export const rbacAddUsersSearchFieldSx = dialogSearchFieldSx

export const rbacAddUsersListSx = {
  mt: 1.5,
  border: `1px solid ${UI_COLOR_BORDER_DIVIDER_SOFT}`,
  borderRadius: '8px',
  overflow: 'auto',
  minHeight: RBAC_ADD_USERS_MIN_VISIBLE_ROWS * RBAC_ADD_USERS_ROW_MIN_HEIGHT,
  maxHeight: RBAC_ADD_USERS_MIN_VISIBLE_ROWS * RBAC_ADD_USERS_ROW_MIN_HEIGHT
}

export const rbacAddUsersAvatarSx = {
  width: 36,
  height: 36,
  bgcolor: UI_COLOR_PRIMARY,
  color: UI_COLOR_WHITE,
  fontSize: 13,
  fontWeight: 700
}

export const rbacAddUsersRowSx = {
  display: 'grid',
  gridTemplateColumns: '40px 40px minmax(0, 1fr) auto',
  columnGap: 1.5,
  alignItems: 'center',
  minHeight: RBAC_ADD_USERS_ROW_MIN_HEIGHT,
  px: 1.5,
  py: 1,
  backgroundColor: UI_COLOR_WHITE,
  borderBottom: `1px solid ${UI_COLOR_BORDER_DIVIDER_SOFT}`,
  '&:last-of-type': {
    borderBottom: 'none'
  }
}

export const rbacAddUsersFilterGroupSx = {
  display: 'inline-flex',
  mb: 2,
  border: `1px solid ${UI_COLOR_SURFACE_300}`,
  borderRadius: '6px',
  overflow: 'hidden',
  backgroundColor: UI_COLOR_WHITE,
  '& .MuiToggleButtonGroup-grouped': {
    minHeight: 36,
    px: 1.75,
    py: 0.75,
    border: 0,
    borderRadius: '0 !important',
    color: UI_COLOR_TEXT_DIALOG_META,
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.2,
    textTransform: 'none',
    gap: 0.75,
    '&:not(:first-of-type)': {
      borderLeft: `1px solid ${UI_COLOR_BORDER_SURVEY_SELECTOR}`,
      marginLeft: 0
    },
    '&.Mui-selected': {
      backgroundColor: UI_COLOR_PRIMARY,
      color: UI_COLOR_WHITE,
      '&:hover': {
        backgroundColor: UI_COLOR_PRIMARY_HOVER,
        color: UI_COLOR_WHITE
      }
    },
    '&:hover': {
      backgroundColor: UI_COLOR_SURFACE_DISABLED,
      color: UI_COLOR_TEXT_DIALOG_META
    },
    '&.Mui-selected:hover': {
      backgroundColor: UI_COLOR_PRIMARY_HOVER,
      color: UI_COLOR_WHITE
    },
    '& svg': {
      color: 'inherit'
    }
  },
  '& .MuiToggleButtonGroup-firstButton': {
    borderTopLeftRadius: '5px !important',
    borderBottomLeftRadius: '5px !important'
  },
  '& .MuiToggleButtonGroup-lastButton': {
    borderTopRightRadius: '5px !important',
    borderBottomRightRadius: '5px !important'
  }
}
